import { isArray } from 'util';
import { NotificationRequest } from '../aux/notification-request';

import { Notification } from '../notification';
import { CheckBuilder } from './check.builder';
import { EmployeeBuilder } from './employee.builder';

const getNotificationRequestFromJson = (json: any) => {
  return (json)
    ? new NotificationRequest(
      json.hash,
      EmployeeBuilder.fromJson(json.user),
      json.startTime,
      json.endTime,
      CheckBuilder.checkFromJson(json.check)
    )
    : null;
};

export class NotificationBuilder {
  static fromJson(json): Notification {
    return (json)
      ? new Notification(
        json.hash,
        json.type,
        json.date,
        getNotificationRequestFromJson(json.request),
        json.read,
        json.answered
      )
      : null;
  }

  static fromJsonList(list): Notification[] {
    return (isArray(list)) ? list.map(NotificationBuilder.fromJson) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/lantago-app/lantago-app-demo/src/app/core/models/builders/notification.builder.ts